import readStringEnv from '@spa/lib/configs/services/readStringEnv';

const imagesHostname = readStringEnv(process.env.NEXT_PUBLIC_IMAGES_HOSTNAME);
export default imagesHostname;
